export default __webpack_public_path__ + "static/media/mahin-arafath-400-400.52a7d21a.png";